export const INVALID_TOKEN_REDIRECT_MSG =
  'Your session has expired, please login to continue to INE for Business';
export const END_USERS_NOT_ALLOWED_MSG = 'End users are not allowed on INE for Business';
export const GENERIC_ERROR_MSG = 'Something went wrong, if it repeats please contact support.';
